module.exports = __webpack_public_path__ + "img/zyjy_05.08a3666e.png";